import React from 'react'
import { useAuth } from 'react-oidc-context'

// Small HOC to inject react-oidc-context auth into a class component
export const withAuth = (Component) => (props) => {
  const auth = useAuth()
  return <Component {...props} auth={auth} />
}
